import React, { useContext } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Contexts/AuthProvider/AuthProvider";
import { FaAngleDoubleRight } from "react-icons/fa";

const Navbar = () => {
  const navigate = useNavigate();
  const { user, logOut } = useContext(AuthContext);
  const menuItems = (
    <React.Fragment>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/dashboard">Dashboard</Link>
      </li>
      <li>
        <Link to="/blogs">Blog</Link>
      </li>
    </React.Fragment>
  );
  const handleLogOut = () => {
    logOut()
      .then(() => {
        toast.success("You have logged out successfully");
        navigate("/");
      })
      .catch((err) => console.error(err));
  };
  return (
    <div className="navbar bg-base-100">
      <label
        htmlFor="my-drawer-2"
        className="drawer-button btn-sm btn lg:hidden"
      >
        <FaAngleDoubleRight className="w-4"></FaAngleDoubleRight>
      </label>
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            {menuItems}
          </ul>
        </div>
        <Link to="/" className="btn btn-ghost normal-case text-xl">
          <img
            className="w-8 text-blue-300"
            src="https://cdn-icons-png.flaticon.com/512/5270/5270476.png"
            alt=""
          />
          reCell
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0">{menuItems}</ul>
      </div>
      <div className="navbar-end">
        {user && user?.uid ? (
          <Link onClick={handleLogOut} className="btn btn-sm">
            Log Out
          </Link>
        ) : (
          <Link to="/login" className="btn btn-sm">
            Login
          </Link>
        )}
      </div>
    </div>
  );
};

export default Navbar;
